import type { SVGProps } from 'react';

interface OpenIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const OpenIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & OpenIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 32 32"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M7 21h18a1 1 0 0 1 .118 1.993L25 23H7a1 1 0 0 1-.117-1.993zm2-6 16-.002a1 1 0 0 1 .118 1.993l-.117.007L9 17a1 1 0 0 1-.117-1.993zM7 9h18a1 1 0 0 1 .118 1.993L25 11H7a1 1 0 0 1-.117-1.993z"
      fill="#4FA9FF"
    />
  </svg>
);
